<script>
import Layout from '@/views/layouts/main'
import ReportController from '@/controller/ReportController'

export default {
  name: 'InvoiceIssuanceTable',
  components: { Layout },
  data() { return { message: 'Abrindo Faturamento de evoluções…' } },
  async mounted() {
    try {
      const result = await new ReportController().openNfseBilling(this.$router)
      if (result?.success === false) this.message = result.message
    } catch (error) {
      this.message = 'Não foi possível abrir o faturamento de evoluções.'
    }
  },
}
</script>
<template>
  <Layout><div class="card"><div class="card-body"><h1 class="h4">Faturamento de evoluções</h1><p role="status">{{ message }}</p><p>Consulta, seleção e preview fiscal são realizados na tela de faturamento de evoluções.</p></div></div></Layout>
</template>
